import { IField } from "../interfaces/inputs/IField";
import { Endpoints } from "../utils/Endpoints";
import { getCampuses, getForms } from "../utils/Helpers";

const genders = [
  {value: 'F', text: 'Female'},
  {value: 'M', text: 'Male'}
]

const campuses = getCampuses()

const forms = getForms();

export const SyncFields: IField[] = [
  { name: "form", type: "select", label: "Class", options: forms, size: {lg: 4}, position: 7 },
  { name: "code", type: "select", label: "Campus", options: campuses, size: {lg: 4}, position: 15 },
].sort((a: IField, b: IField) => a.position - b.position);